
import SideBar from '@/components/SideBar.vue';
import ChatDialog from '@/components/ChatDialog.vue'
import SetTemplateDialog from '@/components/SetTemplateDialog.vue'
import TransactionDialog from '@/components/TransactionDialog.vue';
import SetDetailsDialog from '@/components/SetDetailsDialog.vue';
import SetReportDialog from '@/components/SetReportDialog.vue';
import DetailedReportDialog from '@/components/DetailedReportDialog.vue';
import SetChatbotDialog from '@/components/SetChatbotDialog.vue';



export default {
    name: 'DashboardLayout',
    components: {
    SideBar,
    ChatDialog,
    SetTemplateDialog,
    TransactionDialog,
    SetDetailsDialog,
    SetReportDialog,
    DetailedReportDialog,
    SetChatbotDialog
},
}
